import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { map, Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';

import { AppState } from '@fcom/core/interfaces';
import { profileOrUndefinedIfNotLoggedIn } from '@fcom/core/selectors';
import { finShare } from '@fcom/rx/operators/finShare';
import { CorporateUserRole } from '@fcom/core-api/login';
import { unsubscribe } from '@fcom/core/utils';
import { isCorporateAdminOrTravelBooker } from '@fcom/common/login';

@Component({
  selector: 'fin-corporate-users',
  templateUrl: './corporate-users.component.html',
})
export class CorporateUsersComponent implements OnInit, OnDestroy {
  description$: Observable<string>;
  isAdminOrTravelBooker: boolean;
  selectedUserId: string;
  loading = true;

  subscription = new Subscription();

  constructor(
    private store: Store<AppState>,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    const profile$ = this.store.pipe(profileOrUndefinedIfNotLoggedIn(), finShare());
    this.description$ = profile$.pipe(
      map((profile) =>
        profile?.corporate?.userRole === CorporateUserRole.TRAVELLER
          ? 'CORPORATE.corporatePortal.users.description'
          : 'CORPORATE.corporatePortal.users.adminDescription'
      )
    );

    this.subscription.add(
      this.route.data.subscribe((data) => {
        if (data.userId) {
          this.selectedUserId = data.userId;
        }
      })
    );

    this.subscription.add(
      profile$.subscribe((userProfile) => {
        this.isAdminOrTravelBooker = isCorporateAdminOrTravelBooker(userProfile);
        if (userProfile.corporate?.userRole === CorporateUserRole.TRAVELLER) {
          this.selectedUserId = userProfile?.corporate?.userId;
        }
        this.loading = false;
      })
    );
  }

  ngOnDestroy(): void {
    unsubscribe(this.subscription);
  }

  deselectUser(): void {
    if (this.isAdminOrTravelBooker) {
      this.selectedUserId = null;
    }
  }
}
